<template>
  <el-dialog
    width="40%"
    class="dialog"
    title="添加承运商"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <el-form-item label="承运商" prop="partnershipId">
        <el-select
          v-model="formData.partnershipId"
          placeholder="请选择"
          clearable
          style="width: 100%"
        >
          <el-option
            v-for="item in carrierOption"
            :key="item.partnershipId"
            :label="item.partnerName"
            :value="item.partnershipId"
            v-show="item.partnershipType !== 3"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="保证金初始金额"
        prop="bondAmount"
        v-if="carrierTypeObj[formData.partnershipId] == 2"
      >
        <el-input v-model="formData.bondAmount" placeholder="请输入"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { amountReg } from "@/hooks/regex";
import { getPartnerByBond, savePartnership } from "@/api/oldForNew";
import { Select } from "element-ui";

export default {
  components: {},

  data() {
    return {
      id: "",
      dialogFormVisible: false,
      carrierOption: [], //承运商选项列表
      carrierTypeObj: {},
      formData: {
        partnershipId: "",
        bondAmount: "",
      },
      partnershipTypeOption: { 1: "子公司", 2: "合作商", 3: "总公司" }, //当前用户所属组织 1 子公司 2 第三方 3 总公司
      currPartnershipType: null,
      rules: {
        partnershipId: [
          {
            required: true,
            message: "请选择承运商",
            trigger: ["blur", "change"],
          },
        ],
        bondAmount: [
          {
            required: false,
            message: "请输入初始金额",
            trigger: ["blur", "change"],
          },
          {
            pattern: amountReg,
            trigger: "blur",
            message: "请输入正确金额，不超过100,000,000，最多两位小数",
          },
        ],
      },
      btnLoading: false,
    };
  },
  computed: {},
  watch: {
    dialogFormVisible: function (val, oldVal) {
      if (!val) {
        this.$refs.ruleForm.resetFields();
      }
    },

    "formData.partnershipId": function (val) {
      this.rules.bondAmount[0].required =
        val && this.carrierTypeObj[val] == "2";
    },
  },
  async created() {},
  methods: {
    // 关闭弹框
    closeDialog() {
      this.dialogFormVisible = false;
    },
    // 打开弹框
    async openDialog() {
      await this.getPartnerList();
      this.dialogFormVisible = true;
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 保存和编辑数据接口
    async save() {
      let { statusCode, message } = await savePartnership(this.formData);
      if (statusCode == 200) {
        this.$message.success("保存成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.$message.error(message);
      }
    },
    // 表单重置
    resetFormStatus() {
      this.$refs.ruleForm.resetFields();
    },
    //获取承运商
    async getPartnerList() {
      let { statusCode, data } = await getPartnerByBond();
      if (statusCode == 200) {
        this.carrierOption = data;

        this.carrierTypeObj = this.carrierOption.reduce((obj, item) => {
          obj[item.partnershipId] = item.partnershipType;
          return obj;
        }, {});
      }
    },
  },
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .tips {
    margin-bottom: 10px;
  }
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
  .el-form-item--small.el-form-item {
    &.read-only {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/components/addCarrierDialog.vue